module.exports = __webpack_public_path__ + "img/giant.411ba846.webp";